<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="row">
          <div class="col">
            <div class="card-header row">
              <div class="col">
                <h4 class="card-title float-left">Vehicle Types</h4>
              </div>
              <div class="col">
                <router-link class="btn btn-primary float-right" :to="{path:'/admin/vehicles/vehicle-types/0/create'}">ADD VEHICLE TYPE</router-link>
              </div>
            </div>
            <div class="card-body">
              <DataTable endpoint="vehicles/vehicle-type" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import DataTable from '@kaweb-ltd/admin-vue/DataTable.vue'

  export default {
    components: {
      DataTable
    },
    data () {
      return {
      }
    }
  }
</script>
<style>

</style>
